import React, {useEffect, useState} from 'react';
import {Head, Loading} from "../../components";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Box, Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import ReactPaginate from "react-paginate";
import moment from 'moment-jalaali'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { UserAutocomplete} from './../../components'
import CurrencyFormat from "react-currency-format";
import {useDispatch, useSelector} from "react-redux";
import {orders, period, region} from "../../actions";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {Link, useLocation} from "react-router-dom";
import { DatePicker } from "zaman";
import ExcelDownload from "./excel";
import Checkbox from '@mui/material/Checkbox';
import ArrayFactor from "../../components/Depot/Print/ArrayFactor";
import PeriodAutoComplete from "../../components/Period";
import PrintAccumlative from "../../components/Depot/Print/accumulative";
import RegionAutoComplete from "../../components/Region";
import MarketerLink from "../../components/Marketer/Name";
import EntityNote from "../../components/Note";
import {useNavigate} from "react-router";
import queryString from 'query-string';

const Orders = () => {


    const location = useLocation();
    const history = useNavigate();
    const  AppState  = useSelector(state => state);

    const dispatch = useDispatch();
    const { ready, entities, status,transport, delivery, paid, returned } = useSelector(state => state.orders);

    const [searchTime, setSearchTime] = useState("");
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState([]);

    useEffect(() => {
        if (AppState.period.ready !== 'success') {
            dispatch(period());
        }
    }, [AppState.period.ready]);

    useEffect(() => {
        if (AppState.region.ready !== 'success') {
            dispatch(region());
        }
    }, [AppState.region.ready]);


    const handleChangeSearchInput = (event, type = false) => {

        if (!type) {
            _makeQueryStringParams(event.target.name, event.target.value)

        } else {
            const word = event.target.value;
            const name = event.target.name;

            if (searchTime) {
                clearTimeout(searchTime)
            }
            let loop = setTimeout(()=>{

                _makeQueryStringParams(name, word)

            },500);

            setSearchTime(loop);
        }


    }

    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        _makeQueryStringParams(name, value)

    }



    useEffect(() => {
        if (ready !== 'success') {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [ready]);



    const query = queryString.parse(location.search);

    // state container
    const [params, setParams] = useState({
        page: query.page && !isNaN( query.page) ? parseInt(query.page) : 1,
        transport: query.transport && !isNaN( query.transport) ? parseInt(query.transport) : -1,
        delivery: query.delivery && !isNaN( query.delivery) ? parseInt(query.delivery) : -1,
        month_id: query.month_id && !isNaN( query.month_id) ? parseInt(query.month_id) : '',
        period_id: query.period_id && !isNaN( query.period_id) ? parseInt(query.period_id) : '',
        region_id: query.region_id && !isNaN( query.region_id) ? parseInt(query.region_id) : '',
        limit: query.limit && !isNaN( query.limit) ? parseInt(query.limit) : 100,
        user_id: query.user_id && !isNaN( query.user_id) ? parseInt(query.user_id) : '',
        parent_id: query.parent_id && !isNaN( query.parent_id) ? parseInt(query.parent_id) : '',
        id: query.id ? query.id : '',
        status:query.status && !isNaN(query.status) ? parseInt(query.status) : 1,
        paid:query.paid && !isNaN(query.paid) ? parseInt(query.paid) : -1,
        private:query.private && !isNaN(query.private) ? parseInt(query.private) : -1,
        is_voucher:query.is_voucher && !isNaN(query.is_voucher) ? parseInt(query.is_voucher) : -1,
        is_wallet:query.is_wallet && !isNaN(query.is_wallet) ? parseInt(query.is_wallet) : -1,
        returned:query.returned && !isNaN(query.returned) ? parseInt(query.returned) : -1,
        sort_field: query.sort_field ? query.sort_field : 'id',
        sort_type: query.sort_type ? query.sort_type : 'desc',
        from_date: query.from_date ? query.from_date : '',
        to_date: query.to_date ? query.to_date : '',
        name: query.name ? query.name : '',
        username:query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        marketer_code: query.marketer_code ? query.marketer_code : '',
        mobile: query.mobile ? query.mobile : '',
        gateway: query.gateway ? query.gateway : '',
        notes: query.notes && !isNaN(query.notes) ? parseInt(query.notes) : -1,

    });


    const handleRequest = () => {
        dispatch(orders({
            sort_field: params.sort_field,
            sort_type: params.sort_type,
            page: params.page,
            limit: params.limit,
            id: params.id,
            status: params.status,
            returned : params.returned,
            paid : params.paid,
            private : params.private,
            is_voucher : params.is_voucher,
            is_wallet : params.is_wallet,
            from_date: params.from_date,
            to_date: params.to_date,
            user_id: params.user_id,
            parent_id: params.parent_id,
            name: params.name,
            username: params.username,
            national_code: params.national_code,
            marketer_code: params.marketer_code,
            mobile: params.mobile,
            transport: params.transport,
            delivery: params.delivery,
            month_id: params.month_id,
            period_id: params.period_id,
            region_id: params.region_id,
            gateway: params.gateway,
            notes: params.notes,
        }));
    }

    useEffect(() => {


        handleRequest();
        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.sort_field,
        params.sort_type,
        params.page,
        params.limit,
        params.id,
        params.status,
        params.returned,
        params.paid,
        params.private,
        params.is_voucher,
        params.is_wallet,
        params.from_date,
        params.to_date,
        params.user_id,
        params.parent_id,
        params.name,
        params.username,
        params.national_code,
        params.marketer_code,
        params.mobile,
        params.transport,
        params.delivery,
        params.month_id,
        params.period_id,
        params.region_id,
        params.gateway,
        params.notes,
    ]);


    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'page':
                    if ((n_params.page) !== (query.page)) {
                        n_params.page = parseInt(query.page);
                    }
                    break;
                case 'sort_field':
                    if (n_params.sort_field !== query.sort_field) {
                        n_params.sort_field = query.sort_field;
                        n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                    }
                    break;
                case 'limit':
                    if ((n_params.limit) !== (query.limit)) {
                        n_params.limit = parseInt(query.limit);
                    }
                    break;
                case 'id':
                    if ((n_params.id) !== (query.id)) {
                        n_params.id = (query.id);
                    }
                    break;
                case 'status':
                    if ((n_params.status ) !== (query.status)) {
                        n_params.status = parseInt(query.status);
                    }
                    break;
                case 'paid':
                    if ((n_params.paid ) !== (query.paid)) {
                        n_params.paid = parseInt(query.paid);
                    }
                    break;
                case 'private':
                    if ((n_params.private ) !== (query.private)) {
                        n_params.private = parseInt(query.private);
                    }
                    break;
                case 'is_voucher':
                    if ((n_params.is_voucher ) !== (query.is_voucher)) {
                        n_params.is_voucher = parseInt(query.is_voucher);
                    }
                    break;
                case 'is_wallet':
                    if ((n_params.is_wallet ) !== (query.is_wallet)) {
                        n_params.is_wallet = parseInt(query.is_wallet);
                    }
                    break;
                case 'returned':
                    if ((n_params.returned ) !== (query.returned)) {
                        n_params.returned = parseInt(query.returned);
                    }
                    break;
                case 'from_date':
                    if (n_params.from_date !== query.from_date) {
                        n_params.from_date = query.from_date;
                    }
                    break;
                case 'to_date':
                    if (n_params.to_date !== query.to_date) {
                        n_params.to_date = query.to_date;
                    }
                    break;
                case 'user_id':
                    if ((n_params.user_id) !== (query.user_id)) {
                        n_params.user_id = parseInt(query.user_id);
                    }
                    break;
                case 'parent_id':
                    if ((n_params.parent_id) !== (query.parent_id)) {
                        n_params.parent_id = parseInt(query.parent_id);
                    }
                    break;
                case 'name':
                    if (n_params.name !== query.name) {
                        n_params.name = query.name;
                    }
                    break;
                case 'username':
                    if (n_params.username !== query.username) {
                        n_params.username = query.username;
                    }
                    break;
                case 'national_code':
                    if (n_params.national_code !== query.national_code) {
                        n_params.national_code = query.national_code;
                    }
                    break;
                case 'marketer_code':
                    if (n_params.marketer_code !== query.marketer_code) {
                        n_params.marketer_code = query.marketer_code;
                    }
                    break;
                case 'mobile':
                    if (n_params.mobile !== query.mobile) {
                        n_params.mobile = query.mobile;
                    }
                    break;
                case 'transport':
                    if ((n_params.transport) !== (query.transport)) {
                        n_params.transport = parseInt(query.transport);
                    }
                    break;
                case 'delivery':
                    if ((n_params.delivery) !== (query.delivery)) {
                        n_params.delivery = parseInt(query.delivery);
                    }
                    break;
                case 'month_id':
                    if ((n_params.month_id) !== (query.month_id)) {
                        n_params.month_id = parseInt(query.month_id);
                    }
                    break;
                case 'period_id':
                    if ((n_params.period_id) !== (query.period_id)) {
                        n_params.period_id = parseInt(query.period_id);
                    }
                    break;
                case 'region_id':
                    if ((n_params.region_id) !== (query.region_id)) {
                        n_params.region_id = parseInt(query.region_id);
                    }
                    break;
                case 'gateway':
                    if ((n_params.gateway) !== (query.gateway)) {
                        n_params.gateway = parseInt(query.gateway);
                    }
                    break;
                case 'notes':
                    if ((n_params.notes) !== (query.notes)) {
                        n_params.notes = parseInt(query.notes);
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.sort_field,
        query.sort_type,
        query.page,
        query.limit,
        query.id,
        query.status,
        query.returned,
        query.paid,
        query.private,
        query.is_voucher,
        query.is_wallet,
        query.from_date,
        query.to_date,
        query.user_id,
        query.parent_id,
        query.name,
        query.username,
        query.national_code,
        query.marketer_code,
        query.mobile,
        query.transport,
        query.delivery,
        query.period_id,
        query.month_id,
        query.region_id,
        query.gateway,
        query.notes,
    ]);



    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = parseInt(value);
                break;
            case 'sort_field':
                n_params.sort_field = value;
                n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                break;
            case 'limit':
                n_params.limit = parseInt(value);
                break;
            case 'id':
                n_params.id = (value);
                break;
            case 'status':
                n_params.status = parseInt(value);
                break;
            case 'paid':
                n_params.paid = parseInt(value);
                break;
            case 'returned':
                n_params.returned = parseInt(value);
                break;
            case 'private':
                n_params.private = parseInt(value);
                break;
            case 'is_voucher':
                n_params.is_voucher = parseInt(value);
                break;
            case 'is_wallet':
                n_params.is_wallet = parseInt(value);
                break;
            case 'from_date':
                n_params.from_date = value;
                break;
            case 'to_date':
                n_params.to_date = value;
                break;
            case 'user_id':
                n_params.user_id = parseInt(value);
                break;
            case 'parent_id':
                n_params.parent_id = parseInt(value);
                break;
            case 'name':
                n_params.name = value;
                break;
            case 'username':
                n_params.username = value;
                break;
            case 'national_code':
                n_params.national_code = value;
                break;
            case 'marketer_code':
                n_params.marketer_code = value;
                break;
            case 'mobile':
                n_params.mobile = value;
                break;
            case 'transport':
                n_params.transport = parseInt(value);
                break;
            case 'delivery':
                n_params.delivery = parseInt(value);
                break;
            case 'month_id':
                n_params.month_id = parseInt(value);
                break;
            case 'period_id':
                n_params.period_id = parseInt(value);
                break;
            case 'region_id':
                n_params.region_id = parseInt(value);
                break;
            case 'gateway':
                n_params.gateway = value;
                break;
            case 'notes':
                n_params.notes = parseInt(value);
                break;

        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;
        url += `&sort_field=${n_params.sort_field}`;
        url += `&sort_type=${n_params.sort_type}`;
        url += `&limit=${n_params.limit}`;
        url += `&month_id=${n_params.month_id}`;
        url += `&period_id=${n_params.period_id}`;
        url += `&id=${n_params.id}`;
        url += `&from_date=${n_params.from_date}`;
        url += `&to_date=${n_params.to_date}`;
        url += `&user_id=${n_params.user_id}`;
        url += `&parent_id=${n_params.parent_id}`;
        url += `&name=${n_params.name}`;
        url += `&username=${n_params.username}`;
        url += `&national_code=${n_params.national_code}`;
        url += `&marketer_code=${n_params.marketer_code}`;
        url += `&mobile=${n_params.mobile}`;
        url += `&transport=${n_params.transport}`;
        url += `&delivery=${n_params.delivery}`;
        url += `&status=${n_params.status}`;
        url += `&paid=${n_params.paid}`;
        url += `&returned=${n_params.returned}`;
        url += `&private=${n_params.private}`;
        url += `&is_voucher=${n_params.is_voucher}`;
        url += `&is_wallet=${n_params.is_wallet}`;
        url += `&region_id=${n_params.region_id}`;
        url += `&gateway=${n_params.gateway}`;
        url += `&notes=${n_params.notes}`;


        history(`/orders/${url}`);

    };

    const handleCheckOrder = (event) => {

        let array_index = -1;

        let n_checked = checked;

        array_index = n_checked.indexOf(event.target.value);
        if (array_index > -1) {
            n_checked.splice(array_index, 1);
        } else {
            n_checked.push(event.target.value);
        }
        setChecked([...n_checked]);
    }

    const pageCount = Math.ceil(parseInt(entities.total) / parseInt(entities.per_page));

    return(
        <div style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/', 'title': 'مدیریت سفارشات', 'description': 'سفارشات را مدیریت کنید' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type="search"
                                    id="outlined-name"
                                    label="کد سفارش"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    placeholder={'با , جدا کنید'}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <PeriodAutoComplete list={AppState.period.data} onChange={(name, value) => handleChangeSearchInputWithAutoComplete(name, value)}/>
                            <RegionAutoComplete list={AppState.region.data} onChange={(name, value) => handleChangeSearchInputWithAutoComplete(name, value)}/>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete onChange={(value) => handleChangeSearchInputWithAutoComplete('user_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete label={'بالاسری و زیرمجموعه'} onChange={(value) => handleChangeSearchInputWithAutoComplete('parent_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type="search"
                                    id="outlined-name"
                                    label="موبایل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='mobile'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type="search"
                                    id="outlined-name"
                                    label="نام و نام خانوادگی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='name'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type="search"
                                    id="outlined-name"
                                    label="نام کاربری"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='username'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type="search"
                                    id="outlined-name"
                                    label="کد ملی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='national_code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type="search"
                                    id="outlined-name"
                                    label="کد بازاریابی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='marketer_code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    type="search"
                                    id="outlined-name"
                                    label="ایمیل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='email'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت"
                                    value={params.status}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='status'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    {/*{Object.keys(status).map((item) => {*/}
                                    {/*    return(<MenuItem key={1} value={item}>{status[item]}</MenuItem>);*/}
                                    {/*})}*/}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="پرداخت"
                                    value={params.paid}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='paid'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    {paid && Object.keys(paid).map((item) => {
                                        return(<MenuItem key={1} value={item}>{paid[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت حمل و نقل"
                                    value={params.transport}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='transport'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    {transport && Object.keys(transport).map((item) => {
                                        return(<MenuItem key={1} value={item}>{transport[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت تحویل"
                                    value={params.delivery}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='delivery'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    {delivery && Object.keys(delivery).map((item) => {
                                        return(<MenuItem key={1} value={item}>{delivery[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="مرجوعی"
                                    value={params.returned}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='returned'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    {returned && Object.keys(returned).map((item) => {
                                        return(<MenuItem key={1} value={item}>{returned[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="فاکتور خصوصی"
                                    value={params.private}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='private'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={"-1"}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={"1"}>بله</MenuItem>
                                    <MenuItem key={2} value={"0"}>خیر</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="خرید از بن کالا"
                                    value={params.is_voucher}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='is_voucher'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={"-1"}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={"1"}>بله</MenuItem>
                                    <MenuItem key={2} value={"0"}>خیر</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="خرید از کیف پول"
                                    value={params.is_wallet}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='is_wallet'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={"-1"}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={"1"}>بله</MenuItem>
                                    <MenuItem key={2} value={"0"}>خیر</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="درگاه"
                                    value={params.gateway}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='gateway'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={""}>انتخاب</MenuItem>
                                    {Object.keys(AppState.transaction.gateway).map((item) => {
                                        return(<MenuItem value={item}>{AppState.transaction.gateway[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="یاداشت"
                                    value={params.notes}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='notes'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={"-1"}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={"1"}>دارد</MenuItem>
                                    <MenuItem key={2} value={"0"}>ندارد</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <div className='datepicker-input-container'>
                                    <label>از تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            _makeQueryStringParams('from_date', moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss'))
                                        }}
                                    />

                                </div>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <div className='datepicker-input-container'>
                                    <label>تا تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            _makeQueryStringParams('to_date', moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss'))
                                        }}
                                    />

                                </div>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                            <MenuItem  value="500">500</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        {entities.total > 0 && <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page', selectedItem.selected + 1)}
                            forcePage={parseInt(params.page) - 1}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />}


                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'space-between', alignItems:'center'}}>
                {entities.total > 0 && <div><span>نمایش</span>&nbsp;<span><b>{entities.from}</b>&nbsp;<span>تا</span>&nbsp;<b>{entities.to}</b>&nbsp;<span>از</span>&nbsp;<b>{entities.total}</b></span>&nbsp;<span>مورد</span></div>}
                <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                    <PrintAccumlative ids={checked} object={params} />
                    <Tooltip title="برچسب انبار" >
                        <IconButton>
                            <ArrayFactor is_label={true} object={params} ids={checked} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="فاکتور گروهی" >
                        <IconButton>
                            <ArrayFactor is_label={false} object={params} ids={checked} />
                        </IconButton>
                    </Tooltip>
                    <ExcelDownload ids={checked} object={params} />
                    <Tooltip title="سینک" onClick={() => handleRequest()}>
                        <IconButton>
                            <SyncIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th></th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'id') } >#</th>
                        <th style={{ width: '15%'}} onClick={() => _makeQueryStringParams('sort_field', 'user_id') } >کاربر</th>
                        <th>شهر</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'period_id') } >دوره زمانی</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'total_price') } >مبلغ (تومان)</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'paid') } >وضعیت</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'status') } >پرداخت</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'transport') } >حمل و نقل</th>
                        <th>بازاریاب</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'created_at') } >تاریخ ثبت</th>
                        <th>عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {entities.data && entities.data.map((entity, index) => {
                        return(
                            <tr key={index} style={{ backgroundColor: entity.notes_count > 0 ? '#d5e663':''}}>
                                <td>
                                    <Checkbox
                                        name={'checkbox-' + entity.id}
                                        value={entity.id}
                                        onChange={(event) => handleCheckOrder(event)}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </td>
                                <td>{entity.id}</td>
                                <td><MarketerLink user={entity.user} /></td>
                                <td>{entity.address && entity.address.region_title}</td>
                                <td>{entity.period && entity.period.month && entity.period.month.title + ' (' + entity.period.title + ')' }</td>
                                <td><CurrencyFormat value={entity.total_pay || "ـ"}  displayType={'text'} thousandSeparator={true}  /></td>
                                <td><span className={'order-status-' + entity?.status?.condition.id}>{entity?.status?.condition.name|| "ـ"}</span></td>
                                <td><span className={'order-status-' + entity?.paid_status?.condition?.id}>{entity?.paid_status?.condition?.name|| "ـ"}</span></td>
                                <td><span>{entity?.forwarding?.name|| "ـ"}</span></td>
                                <td>{entity?.marketer?.user?.name || "ـ"}</td>
                                <td style={{ direction: 'ltr'}}>{moment(entity.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td>
                                    <Tooltip title="مشاهده جزئیات">
                                        <Link to={`/orders/${entity.id}`}>
                                            <IconButton>
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Link>
                                    </Tooltip>
                                    <EntityNote id={entity.id} onComplete={() => handleRequest()} />
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>

            {entities.total > 0 &&  <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page', selectedItem.selected + 1)}
                forcePage={parseInt(params.page) - 1}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />}

            {loading && <Loading/>}
        </div>

    );
}


export default Orders;
